import { DateTime } from 'luxon';
import { OrderFieldsFragment } from '../../graphql';

const errorMessage =
	'There was a problem with your order. Try sending it again. If the problem persists, please contact support.';

export const getOrderTitle = (
	status: OrderFieldsFragment['status']['status'],
	time: OrderFieldsFragment['time']
): string => {
	if (!status) {
		return 'Loading order...';
	}

	switch (status) {
		case 'ORDER_PROCESSING':
			return 'Processing your order...';
		case 'ORDER_SCHEDULED': {
			if (!time) {
				return errorMessage;
			}

			const duration = DateTime.fromISO(time).toRelative();

			return `Your order has been scheduled for ${duration} from now.`;
		}
		case 'ORDER_SENT':
			return 'Waiting for the store to process your order...';
		case 'ORDER_RECEIVED':
			return "Preparing your order... we'll let you know when it's ready.";
		case 'ORDER_READY':
			return 'Your order is ready for pickup!';
		case 'ORDER_COMPLETE':
			return 'Thanks for your order!';
		case 'ORDER_REFUND_REQUESTED':
			return 'A refund is being processed for your order.';
		case 'ORDER_REFUND_PROCESSED':
			return 'Your order has been refunded.';
		case 'ORDER_ERROR':
			return errorMessage;
		default:
			return errorMessage;
	}
};
